document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    reveals.forEach((element) => observer.observe(element));
  } else {
    reveals.forEach((element) => element.classList.add('is-visible'));
  }

  document.querySelectorAll('.mobile-menu').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      document.body.classList.toggle('menu-open', menu.open);
    });
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => menu.removeAttribute('open'));
    });
    menu.querySelectorAll('[data-menu-close]').forEach((button) => {
      button.addEventListener('click', () => menu.removeAttribute('open'));
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantSelect = form.querySelector('[name="id"]');
    const addButton = form.querySelector('[name="add"]');
    const buttonLabel = addButton?.querySelector('[data-add-label]');
    const price = document.querySelector('[data-main-product-price]');
    if (!variantSelect || !addButton) return;

    variantSelect.addEventListener('change', () => {
      const selected = variantSelect.options[variantSelect.selectedIndex];
      const available = selected.dataset.available === 'true';
      addButton.disabled = !available;
      if (buttonLabel) buttonLabel.textContent = available ? 'Add to cart' : 'Sold out';
      if (price && selected.dataset.price) price.textContent = selected.dataset.price;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', selected.value);
      window.history.replaceState({}, '', url.toString());
    });
  });
});
